<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="470">
    <v-card>
        <v-toolbar dense>
            BORROWED ITEMS
             | <span class="ml-2" :class="borrowed.status!='active'?'text-warning':'text-success'">{{borrowed.status}}</span>
            <v-spacer/>
             <v-icon @click="emitToParent('close')">mdi-close</v-icon>
        </v-toolbar>
          <v-data-table
              class="va-table ma-2"
              dense
              :headers="headers"
              disable-sort
              :items="borroweds"
              hide-default-footer
              >
              <template v-slot:body="{ items }">
                  <tbody>
                  <tr v-for="(item,index) in items" :key="index">
                    <td>{{item.product_code}}</td>
                    <td>{{item.unit_price}}</td>
                    <td>{{item.quantity}}</td>
                    <td class="text-right">{{$money($IsNum(item.unit_price) * $IsNum(item.quantity))}}</td>
                  </tr>
                   <tr style="background: #efefef;">
                    <th colspan="4" class="text-right">TOTAL AMOUNT: {{$money(TOTAL)}}</th>
                  </tr>
                  </tbody>
              </template>
          </v-data-table>
        <v-card-actions>
                <v-btn color="warning" small   @click="text ='close', emitToParent()">Close</v-btn>
            <v-spacer></v-spacer>
            <template v-if="borrowed.status == 'active'">
              <v-btn  small color="info" @click="item.status='returned', update()">returned</v-btn>
              <v-btn  small color="secondary" @click="item.status='paid', update()">paid</v-btn>
            </template>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    data: () => ({
      borroweds:[],
      item:{},
        headers:[
          {text:"CODE"},
          {text:"PRICE"},
          {text:"QTY"},
          {text:"AMOUNT", align:"right"}
        ]
    }),
  props: {
    show: {
        type: Boolean,
        default: false
    },
    borrowed: {
        type: Object,
        default: ()=>{}
    }
  },
  watch:{
      show(val) {
          if(val){
            this.item = this.borrowed
            this.getitems()
          }
      }
  },
  computed:{
    TOTAL(){
        var total = this.borroweds.reduce((res,item)=>res+=this.$IsNum(item.unit_price) * this.$IsNum(item.quantity),0)
        return total
    }
  },
  methods: {
    emitToParent () {
      this.$emit('DialogEvent', "")
    },
    getitems() {
      this.$http.post("borrow/view_items", {id:this.borrowed.id}).then(response => {
          response.data.items !=null?this.borroweds = response.data.items : this.borroweds=[]
          }).catch(e => {
          console.log(e.data)
      })
    },
    update() {
      this.$http.post("borrow/update", this.borrowed).then(response => {
         this.GET_RESPONSE(response)
          }).catch(e => {
          console.log(e.data)
      })
    }
  }
}
</script>
